import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { AppState } from '../..';

interface ModalState {
  openModals: Record<string, boolean>;
}

const initialState: ModalState = {
  openModals: {},
};

const modalSlice = createSlice({
  name: 'modal',
  initialState: initialState,
  reducers: {
    openModal: (state, action: PayloadAction<string>) => {
      state.openModals[action.payload] = true;
    },

    closeModal: (state, action: PayloadAction<string>) => {
      state.openModals[action.payload] = false;
    },

    closeAllModals: (state) => {
      state.openModals = {};
    },

    toggleModal: (state, action: PayloadAction<string>) => {
      const modalId = action.payload;
      state.openModals[modalId] = !state.openModals[modalId];
    },
  },
});

export const { openModal, closeModal, closeAllModals, toggleModal } = modalSlice.actions;

// Corrected selector to properly navigate the state tree
export const selectIsModalOpen = (state: AppState, modalId: string): boolean => !!state.modal.openModals[modalId];

export default modalSlice.reducer;
